import React, { useState } from "react";
import classes from "./GlossarySection.module.css";
import img from "../../assets/czj.png";
import { createSlug } from "../../utils/utils";
import ModalVideo from "react-modal-video";

const GlossaryEntry = ({ item }: any) => {
  const [modal, setModal] = useState(false);

  return (
    <>
      <div
        key={createSlug(item.headline)}
        id={createSlug(item.headline)}
        className={classes.innerWrapper}
      >
        <h3>{item.headline}</h3>
        <div className={classes.content}>
          <img
            src={img}
            alt="img"
            className={classes.videoButton}
            onClick={() => setModal(true)}
          />
          <ModalVideo
            youtube={{ autoplay: 1, mute: 1 }}
            channel="youtube"
            isOpen={modal}
            videoId={item.url}
            onClose={() => setModal(false)}
          />
          <div>
            <p dangerouslySetInnerHTML={{ __html: item.body }} />
          </div>
        </div>
      </div>
      <hr />
    </>
  );
};

const GlossarySection = (data: any) => {
  return (
    <div className={classes.wrapper}>
      <h2 id={data.data.letter}>{data.data.letter}</h2>
      <div>
        {data.data.children.map((item: any) => (
          <GlossaryEntry item={item} key={item.headline} />
        ))}
      </div>
    </div>
  );
};

export default GlossarySection;
